import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { BookingRequestValidation } from 'uplisting-frontend/validations';

export default class BookingRequestRepositoryService extends BaseRepositoryService<
  ModelRegistry['booking-request']
> {
  recordName = 'booking-request';
  implementMethods = ['buildChangeset'];

  validation = BookingRequestValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/booking-request': BookingRequestRepositoryService;
  }
}
